<template>
    <div class="general-config-box">
        <div class="view-box">
            <div class="view-wrap">
                <div class="view" :class="{'landscape-background': currentScreen === 1}">
                    <div v-if="currentScreen === 2" class="portrait-view">
                        <div class="top">
                            <div class="top-item">
                               <div class="left-item">
                                    <div class="item" v-for="(item, index) in portraitTopBtnList" :key="'left'+item.tag">
                                        <div v-show="index <= 1" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束': '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="title">这里是你的房间主题<span class="title-icon"></span></div>
                                <div class="right-item">
                                    <div class="item" v-for="(item, index) in portraitTopBtnList" :key="'right'+item.tag">
                                        <div v-show="index === 2" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束': '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="bottom-item" v-show="item.checked" v-for="item in portraitBottomBtnList" :key="item.tag">
                                <div class="icon" :class="[item.icon]"></div>
                                <div class="item-name" v-show="item.checked">{{ item.viewName }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="landscape-view">
                        <div class="top">
                            <div class="top-item">
                                <div class="left-item">
                                    <div class="item" v-for="(item, index) in landscapeTopBtnList" :key="'left'+item.tag">
                                        <div v-show="index <= 1" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束房间': '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="title">这里是你的房间主题<span class="title-icon"></span></div>
                                <div class="right-item">
                                    <div class="item" v-for="(item, index) in landscapeTopBtnList" :key="'right'+item.tag">
                                        <div v-show="index === 2" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束房间': '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="content" v-for="(item, index) in landscapeBottomBtnList" :key="item.tag">
                                <div class="line" v-show="index === landscapeBottomBtnList.length-2"></div>
                                <div class="bottom-item" v-show="item.checked">
                                    <div class="icon" :class="[item.icon]"></div>
                                    <div class="item-name" v-show="item.checked">{{ item.viewName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="control-box">
            <div class="general-config">
                 <div class="title bold">通用配置</div>
                <div class="control-item">
                    <div class="item-name">屏幕旋转</div>
                    <el-select v-model="rotate" placeholder="请选择" @change="rulesChange($event, 'screen_rotate_type')">
                        <el-option
                            v-for="item in screenRotateTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="control-item">
                    <div class="item-name">进房后屏幕默认方向</div>
                    <el-select v-model="currentScreen" placeholder="请选择" @change="rulesChange($event, 'screen_default_direction')">
                        <el-option
                            v-for="item in screenDefaultDirectionOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  props: {
    config: {
      type: Object,
      default: Object
    }
  },
  data () {
    return {
      // 取默认值因为父组件传的config可能会缺少按钮 页面控制面板展示的按钮要是全部按钮
      portraitTopBtnList: [].concat(this.config.portrait.topView.left_item, this.config.portrait.topView.right_item),
      portraitBottomBtnList: this.config.portrait.bottomView.items,
      landscapeTopBtnList: [].concat(this.config.landscape.topView.left_item, this.config.landscape.topView.right_item),
      landscapeBottomBtnList: this.config.landscape.bottomView.items,
      currentScreen: this.config.rules.screen_default_direction,
      rotate: this.config.rules.screen_rotate_type,
      screenRotateTypeOptions: [
        {
          label: '自动旋转',
          value: 2
        },
        {
          label: '不旋转',
          value: 1
        }
      ],
      screenDefaultDirectionOptions: [
        {
          label: '横屏',
          value: 1
        },
        {
          label: '竖屏',
          value: 2
        }
      ]
    }
  },
  created () {
    this.getConfigData()
  },
  watch: {
    config (val) {
      // 获取父组件调用接口请求后的配置文件
      this.config = val
      this.getConfigData()
      this.currentScreen = this.config.rules.screen_default_direction
    }
  },
  methods: {
    // 获取对应的配置参数
    getConfigData () {
      const portraitObj = this.transConfigData(this.portraitTopBtnList, this.portraitBottomBtnList, 'portrait')
      this.portraitTopBtnList = portraitObj.top
      this.portraitBottomBtnList = portraitObj.bottom
      const landscapeObj = this.transConfigData(this.landscapeTopBtnList, this.landscapeBottomBtnList, 'landscape')
      this.landscapeTopBtnList = landscapeObj.top
      this.landscapeBottomBtnList = landscapeObj.bottom
    },
    rulesChange (val, type) {
      if (type === 'screen_default_direction') {
        this.currentScreen = val
      }
    },
    transConfigData (top, bottom, item) {
      // 根据最新配置文件更新view
      bottom.forEach(defaultItem => {
        if (this.config[item].bottomView.items.some(item => item.tag === defaultItem.tag)) {
          this.$set(defaultItem, 'checked', true)
        } else {
          this.$set(defaultItem, 'checked', false)
        }
        switch (defaultItem.tag) {
          case 20:
            defaultItem.viewName = '讨论'
            defaultItem.controlName = '讨论功能'
            break
          case 21:
            defaultItem.viewName = '成员'
            defaultItem.controlName = '成员列表功能'
            break
          case 22:
            defaultItem.viewName = '共享'
            defaultItem.controlName = '共享功能'
            break
          case 23:
            defaultItem.viewName = '摄像头'
            defaultItem.controlName = '摄像头功能'
            break
          case 24:
            defaultItem.viewName = '麦克风'
            defaultItem.controlName = '麦克风功能'
            break
          case 25:
            defaultItem.viewName = '上台'
            defaultItem.controlName = '上台功能'
            break
        }
      })

      const concatArray = [].concat(this.config[item].topView.left_item, this.config[item].topView.right_item)
      // 顺序问题
      switch (concatArray.length) {
        case 3:
          top = concatArray
          break
        case 2: case 1:
          {
            const uncheckedArray = this.getDifference(top, concatArray, 'tag')
            uncheckedArray.forEach((item) => {
              item.checked = false
            })
            if (this.config[item].topView.right_item.length) {
              const array = this.config[item].topView.left_item.concat(uncheckedArray).concat(this.config[item].topView.right_item)
              top = JSON.parse(JSON.stringify(array))
            } else {
              top = JSON.parse(JSON.stringify(concatArray.concat(uncheckedArray)))
            }
          }
          break
      }

      top.forEach((defaultItem, index) => {
        switch (defaultItem.tag) {
          case 1:
            defaultItem.controlName = '更多按钮'
            // defaultItem.icon = 'roomkit_more'
            break
          case 2:
            defaultItem.controlName = '窗口最小化按钮'
            // defaultItem.icon = 'roomkit_nav_minimize'
            break
          case 3:
            defaultItem.controlName = '离开/结束按钮'
            break
        }
        if (concatArray.some(item => item.tag === defaultItem.tag)) {
          this.$set(defaultItem, 'checked', true)
        }
      })
      return { top, bottom }
    },
    // 求两个数组对象的差集
    getDifference (arr1, arr2, param) {
      return Object.values(arr1.concat(arr2).reduce((acc, cur) => {
        if (acc[cur[param]] && acc[cur[param]][param] === cur[param]) {
          delete acc[cur[param]]
        } else {
          acc[cur[param]] = cur
        }
        return acc
      }, {}))
    }
  }
}
</script>
<style lang="less" scoped>
.general-config-box {
    display: flex;
    border-radius: 4px;
    width: 100%;
    min-height: 100%;
    .view-box {
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 160px;
        .screen-switch {
            flex-shrink: 0;
            margin: 24px 0;
            display: flex;
            width: 160px;
            height: 32px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
            border-radius: 4px;
        }
        .view-wrap {
            display: flex;
            align-items: center;
            flex-grow: 1;
            .view {
                background-color: #171717;
                background-image: url('../assets/img/portrait-screen.png');
                background-size: cover;
                &.landscape-background {
                    background-image: url('../assets/img/landscape-screen.png');
                }
                .portrait-view, .landscape-view {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 375px;
                    height: 667px;
                    .top {
                        position: relative;
                        display: flex;
                        align-items: center;
                        padding: 0 14px;
                        height: 48px;
                        background-color: rgba(0, 0, 0, 0.8);
                        .top-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 100%;
                            .title {
                                position: absolute;
                                left: 50%;
                                transform: translate(-50%);
                                font-size: 16px;
                                color: #fff;
                                .title-icon {
                                    display: inline-block;
                                    margin-left: 3px;
                                    width: 12px;
                                    height: 12px;
                                    background-image: url('../assets/img/open-icon.png');
                                    background-size: cover;
                                }
                            }
                            .left-item {
                                display: flex;
                                align-items: center;
                                .item{
                                    &:nth-child(1){
                                        margin-right: 18px;
                                    }
                                }
                            }
                            .icon {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                min-width: 24px;
                                height: 24px;
                                font-size: 15px;
                                color: #FF5248;
                                background-size: cover;
                                &.roomkit_more {
                                    background-image: url('../assets/img/more-icon.png');
                                }
                                &.roomkit_nav_minimize {
                                    background-image: url('../assets/img/minimize-icon.png');
                                }
                            }
                        }
                    }
                    .bottom {
                        display: flex;
                        justify-content: center;
                        padding: 0 16px;
                        height: 55px;
                        background-color: rgba(0, 0, 0, 0.8);
                        .bottom-item {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-top: 6px;
                            margin-right: 31px;
                            width: 44px;
                            height: 44px;
                            .icon {
                                margin-bottom: 4px;
                                width: 25px;
                                height: 25px;
                                background-size: cover;
                                &.roomkit_discussion {
                                    background-image: url('../assets/img/discussion-icon.png');
                                }
                                &.roomkit_member {
                                    background-image: url('../assets/img/member-icon.png');
                                }
                                &.roomkit_share {
                                    background-image: url('../assets/img/share-icon.png');
                                }
                                &.roomkit_close_camera {
                                    background-image: url('../assets/img/camera-icon.png');
                                }
                                &.roomkit_close_microphone {
                                    background-image: url('../assets/img/microphone-icon.png');
                                }
                                &.roomkit_toolbar_onstage_icon2 {
                                    background-image: url('../assets/img/on-stage-icon.png');
                                }
                            }
                            .item-name {
                                font-size: 18px;
                                color: #FFFFFF;
                                zoom: 0.5;
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }

                    }
                }
                .landscape-view {
                    width: 667px;
                    height: 375px;
                    .top{
                        .top-item{
                            .title {
                                font-size: 17px;
                            }
                        }
                    }
                    .bottom {
                        .content {
                            display: flex;
                            align-items: center;
                            .line {
                                margin-right: 8px;
                                width: 1px;
                                height: 28px;
                                background-color: #666666;
                            }
                            .bottom-item {
                                margin-right: 8px;
                                align-self: flex-start;
                            }
                        }

                    }
                }
            }
        }
    }
    .control-box {
        z-index: 6;
        position: fixed;
        right: 0;
        overflow: scroll;
        display: flex;
        flex-direction: column;
        width: 272px;
        height: calc(100% - 64px);
        background-color: #FFFFFF;
        color: #636c78;
        .title {
            margin-bottom: 20px;
            font-size: 13px;
            font-weight: 600;
            color: #33383E
        }
        .general-config{
            padding: 24px 24px 8px;
            .control-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;
                font-size: 12px;
                &:last-child{
                    margin-bottom: 0;
                }
                .item-name {
                    color: #33383e;
                }
            }
        }
    }
}
</style>
<style scoped>
.el-select >>> .el-input__inner {
    padding-right: 0;
    padding-left: 10px;
    width: 86px;
    height: 28px;
    font-size: 12px;
    color: #33383e;
}
.el-select >>> .el-input__icon {
    display: flex;
    align-items: center;
    width: 12px;
    height: 28px;
    color: #919DAB;
}
.el-select >>> .el-input .el-select__caret.el-icon-arrow-up::before {
    background: url('../assets/img/arrow-icon.png');
    background-size: cover;
    transform: rotate(0deg);
    line-height: 14px;
}
.el-select >>> .el-input .el-select__caret.is-reverse.el-icon-arrow-up::before {
     transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/views/general-config.vue